import UserInfoUtils from '../../shared/UserInfoUtils';
import loggedOutCTAUpdate from '../Cta';
import pinnedNavCTAUpdate from './pinnedNavCTAUpdate';
import overallScoreCTAUpdate from './overallScoreCTAUpdate';
import logInPopupCTAUpdate from './logInPopupCTAUpdate';
import urlTiersCTAUpdate from './urlTiersCTAUpdate';

export default () => {

    UserInfoUtils.onCRUserInfoReady(() => {
        loggedOutCTAUpdate();
        pinnedNavCTAUpdate();
        overallScoreCTAUpdate();
        logInPopupCTAUpdate();
        urlTiersCTAUpdate();
    });

}



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/components/MembershipPageUpdate/index.js